import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import actions from './../../Redux/Actions/app';
import styled, { keyframes } from 'styled-components'
import { Headline3, Overline2, Headline5, Next, Back, ButtonContainer, InlineBlue } from './../../Components/Common';
import withRouter from './../../Utilities/withRouter'
import { Industries } from '../../Components/Industries';
import Feature,{ featureList } from './Components/Feature';
import PreviewBox from '../../Components/PreviewBox';
import DevicePreview from '../../Components/PreviewBox/DevicePreview';

const Left = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 0;
    min-width: 845px;
    flex-grow: 1;
    width: auto;
    height: 785px;
    overflow: hidden;
    box-sizing: border-box;         /* Opera/IE 8+ */
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    @media (min-width: 319px) and (max-width: 767px) {
        height: unset;
        min-width: unset;
        position: unset;
        flex: 1;
        overflow: unset;
        overflow-x: hidden;
        overflow-y: auto;
        justify-content: center;
        ${Overline2}{
            font-size: 26px;
        }
        ${Headline3} {
            font-size: 35px;
        }
        ${Headline5}{
            font-size: 15px;
        }
        ${Back} {
            flex: 1;
            order: 2;
            flex-basis: 100%;
        }
        ${Next} {
            flex: 1;
            order: 1;
            flex-basis: 100%;
            margin-top: 0;
        }
    }
    @media (min-width: 768px) and (max-width: 1025px){
        min-width: 404px;
        flex: 1;
        ${Overline2}{
            font-size: 26px;
        }
        ${Headline3}{
            font-size: 35px;
        }
        ${Headline5}{
            font-size: 15px;
        }
    }
    @media (min-width: 1025px) and (max-width: 1360px){
        min-width: 404px;
        flex: 1;
    }
`;

const FadeInFrames = keyframes`
    0% {
    opacity: 0;
    transform: translate(0,20px);
    }
    100% {
        opacity: 1;
        transform: translate(0,0);
    }
`;

const FeatureContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1;
    max-height: 685px;
    overflow-y: auto;
    overflow-x: visible;
    flex-wrap: wrap;
    gap: 40px 30px;
    &>*{
        animation-name: ${FadeInFrames};
        animation-duration: 0.4s;
        animation-fill-mode: backwards;
    }
    box-sizing: border-box;         /* Opera/IE 8+ */
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    
    @media (min-width: 319px) and (max-width: 767px) {
        max-height: unset;
        min-width: unset;
        flex: 1;
        padding-top: 20px;
        justify-content: center;
        ::-webkit-scrollbar {
            width: 0px;
            background: transparent; /* make scrollbar transparent */
        }
    }
    @media (min-width: 768px) and (max-width: 1306px){
        justify-content: center;
    }
    
`;


const Centered = styled.div`
    display: flex;
    flex-grow: 1;
    flex-wrap: wrap;
    gap: 10px;
    flex-direction: row;
    padding-left: 60px;
    max-width: 1440px;
    margin: 0px auto auto auto;
    margin-left: auto;
    margin-right: auto;
    overflow-x: hidden;
    overflow-y: auto;
    box-sizing: border-box;         /* Opera/IE 8+ */
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    @media (min-width: 319px) and (max-width: 767px) {
        max-width: 100vw;
        max-height: 100vh;
        overflow-x: hidden;
        overflow-y: auto;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 20px;
        margin: 0px auto auto auto;
    }
    @media (min-width: 319px) and (max-width: 481px) {
        ::-webkit-scrollbar {
            width: 0px;
            background: transparent; /* make scrollbar transparent */
        }
    }
    @media (min-width: 768px) and (max-width: 1025px){
        max-width: 100vw;
        max-height: 100vh;
        overflow-x: hidden;
        overflow-y: auto;
        padding-left: 20px;
        padding-right: 0px;
        padding-top: 0px;
        margin: 0px 0px 0px 0px;
        gap: 0px;
    }
    @media (min-width: 1025px) and (max-width: 1360px){
        max-width: 100vw;
        max-height: 100vh;
        overflow-x: hidden;
        overflow-y: auto;
        padding-left: 20px;
        padding-right: 0px;
        padding-top: 0px;
        margin: 0px 0px 0px 0px;
    }

`;

class Step2 extends Component {
    static propTypes = {
        updateField: PropTypes.func,
        industry: PropTypes.string,
        features: PropTypes.array,
        navigate: PropTypes.func
    };
    
    onfeatureClicked = (feature) =>{
       
        const { updateField, features } = this.props;
        let _features = features ? [...features] : [];
        let found = _features.findIndex(f => f === feature.id); 
        if(found > -1){
            _features.splice(found,1);
        }else{
            _features.push(feature.id);
        }
        updateField("features", _features)
    }
    renderFeatures = (industry, features) =>{
        let elements = [];
        for(let i=0; i<featureList.length; i++){
            elements.push((
                <Feature key={'feature_' + featureList[i].id} industry={industry} feature={featureList[i]} onSelected={()=> this.onfeatureClicked(featureList[i]) } selected={features.indexOf(featureList[i].id) > -1} />)
            );
        }
        return elements;
    };
    componentDidMount(){
        const { navigate, industry } = this.props;
        window.gtag('event', 'screen_view', {
            'app_name': 'App Creator',
            'screen_name': 'Step 2'
        });
        if(!industry){
            setTimeout(()=> navigate('/step-1', {replace:true}));
        }   
    }
    render() {
        const { navigate, features, industry } = this.props;
        //let industryImage = null;
        let theme = 'light'
        if(industry){
            let index = Industries.findIndex(t => t.id === industry);
            if(index > -1)
                theme = Industries[index].theme;
                //industryImage = Industries[index].preview;
        }
        return (<Centered>
            <Left>
                <Headline3 style={{marginTop: "30px"}}><Overline2 style={{fontSize:"30px"}}>Step 2:</Overline2><br/>Select Your Features</Headline3>
                <Headline5>
                    <span style={{ fontWeight: 700 }}>You selected <InlineBlue>{industry}</InlineBlue> as your business.</span><br/>
                    Phunware's App Creator offers a wide selection of widgets and modules you can add to your app; select everything you're interested in and we'll include them in your app design.
                </Headline5>
                <FeatureContainer>
                    {this.renderFeatures(industry, features)}
                </FeatureContainer>
                <ButtonContainer>
                    <Back onClick={e => { e.preventDefault(); navigate(`/step-1`);}}>Back</Back>
                    <Next onClick={e => { e.preventDefault(); navigate(`/step-3`);}} disabled={!(industry && features &&  features.length > 0)}>Next: Content</Next>
                </ButtonContainer>
            </Left>
            <PreviewBox title={industry}>
                {/* {(!features || features.length === 0) && industryImage && <img src={industryImage} />} */}
                <DevicePreview industry={industry} features={features} theme={theme} />
            </PreviewBox>
        </Centered>);
    }
}
function stateToProps(state){
    return {...state.app};
};
export default connect(stateToProps,actions)(withRouter(Step2));

